import moment from "moment";

class permissions {
  constructor(
    permisoId,
    segmId,
    segmDespl,
    segmNombre,
    permNombre,
    fecDesde,
    fecHasta
  ) {
    this.permisoId = permisoId;
    this.segmId = segmId;
    this.segmDespl = segmDespl;
    this.segmNombre = segmNombre;
    this.permNombre = permNombre;
    this.from = moment(fecDesde).utc().format("DD-MM-YYYY");
    this.to = fecHasta ? moment.utc(fecHasta).format("DD-MM-YYYY") : " ";
  }

  static fromJson({
    permisoId,
    segmId,
    segmDespl,
    segmNombre,
    permNombre,
    fecDesde,
    fecHasta,
  }) {
    return new permissions(
      permisoId,
      segmId,
      segmDespl,
      segmNombre,
      permNombre,
      fecDesde,
      fecHasta
    );
  }
}

export default permissions;
